import { createFileRoute } from '@tanstack/react-router'
import { AjudaFaq } from '@/features/ajuda-faq'

export const Route = createFileRoute('/_authenticated/ajuda-faq/')({
  component: AjudaFaq,
})

